var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07108 15.5564C7.26624 15.7515 7.58303 15.7515 7.77819 15.5564L14.8314 8.50314L14.7031 13.7764C14.6963 14.0522 14.9141 14.2816 15.1908 14.2885C15.4669 14.2952 15.696 14.0771 15.7027 13.801L15.8493 7.77836C15.8493 7.51107 15.7453 7.26005 15.5564 7.07108C15.3676 6.88228 15.1164 6.77816 14.8371 6.77851L8.82665 6.92488C8.55053 6.9316 8.33256 7.16088 8.3391 7.43683C8.34546 7.71295 8.57492 7.93109 8.85105 7.92438L14.1356 7.78472L7.07108 14.8493C6.87592 15.0444 6.87592 15.3612 7.07108 15.5564Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLink);
export default __webpack_public_path__ + "static/media/arrow-link.4b6e9b45f4d7ba2d184230e161c169e7.svg";
export { ForwardRef as ReactComponent };